import { bool, func } from "prop-types";
import { connect } from "react-redux";

import withTaskSelectionMode from "../HOCs/withTaskSelectionMode";
import { toggleSortByPriority } from "../actions/creators";

import TaskSelectAll from "../TaskSelectAll";
import BarsSortSolidV6 from "../../../../shared/v2/Icomoon/Icons/BarsSortSolidV6";
import Tooltip from "../../../../shared/v2/Tooltip";

const Label = ({ isTasksSelectionMode, isCompletedTab, isSortedByPriority, onToggleSortByPriority }) => (
  <div className="tw-text-neutral-gray-50 tw-font-semibold tw-flex tw-items-center tw-mb-12px tw-text-12px">
    {isTasksSelectionMode ? <TaskSelectAll /> : <div>Tasks</div>}
    <div className="tw-ml-auto tw-mr-24px tw-flex tw-items-center tw-gap-24px">
      <div className="tw-w-[56px]">{isCompletedTab ? "Date" : "Due Date"}</div>
      <div className="tw-w-24px tw-flex tw-justify-center">Who</div>
      <Tooltip
        placement="top"
        className="tw-ml-12px tw-w-[48px] tw-flex tw-justify-end tw-whitespace-nowrap"
        content={isSortedByPriority ? "Back to default order" : "Sort by priority"}
        trigger={
          <button
            type="button"
            aria-pressed={isSortedByPriority}
            className={`tw-p-0 tw-border-0 tw-bg-transparent tw-font-semibold tw-flex tw-items-center tw-gap-[6px] tw-cursor-pointer ${
              isSortedByPriority ? "tw-text-neutral-gray-75" : "tw-text-neutral-gray-50"
            }`}
            onClick={onToggleSortByPriority}
          >
            Priority
            <BarsSortSolidV6 size="m" />
          </button>
        }
      />
    </div>
  </div>
);

const mapStateToProps = (state) => ({
  isCompletedTab: state.tdpTasksReducer.primaryActiveList.indexOf("completed_at") > -1,
  isSortedByPriority: state.tdpTasksReducer.isSortedByPriority,
});

const mapDispatchToProps = (dispatch) => ({
  onToggleSortByPriority: () => dispatch(toggleSortByPriority()),
});

Label.propTypes = {
  isTasksSelectionMode: bool,
  isCompletedTab: bool,
  isSortedByPriority: bool,
  onToggleSortByPriority: func,
};

Label.defaultProps = {
  isTasksSelectionMode: false,
  isCompletedTab: false,
  isSortedByPriority: false,
  onToggleSortByPriority: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(withTaskSelectionMode(Label));
